"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        duration: 9000,
        closeButton: true,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          title: "group-[.toast]:font-bold group-[.toast]:text-sm",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "bg-slate-50! text-slate-900! hover:bg-slate-300! border-slate-400!",
        },
        style: {
          // ライトモードのときのスタイル（invert=trueなので暗い背景）
          backgroundColor: "rgb(15 23 42)", // bg-slate-900と同じ色
          color: "rgb(248 250 252)", // text-slate-50と同じ色
          borderColor: "rgb(30 41 59)", // bg-slate-800と同じ色（少し明るめ）
        },
        descriptionClassName: "!text-zinc-300", // 説明文を明るいグレーに
      }}
      invert={true}
      {...props}
    />
  );
};

export { Toaster };
